app.service('partnerService', function ($http) {

  // Routes -----------------------------------------

  this.updateInsertPartnersInSGContacts = obj => {
    return $http.post('/partner/updateInsertPartnersInSGContacts', obj)
      .then(function (response) {
        return response
      })
  }

})
